/* Teacher Appreciation Sale – shared behaviour for ta-* sections */
(function () {
  if (window.__ftsLoaded) return;
  window.__ftsLoaded = true;
  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function initCountdown(scope) {
    // Live countdown to the sale start (default 9:00 AM ET = UTC-05:00 on Nov 3), then to data-end
    scope.querySelectorAll('[data-fts-countdown]').forEach(function (el) {
      if (el.__ftsTimer) clearInterval(el.__ftsTimer);
      var date = el.getAttribute('data-date') || '';
      if (!/^\d{4}-\d{2}-\d{2}$/.test(date)) return;
      var time = el.getAttribute('data-time') || '09:00';
      var offset = el.getAttribute('data-offset') || '-05:00';
      var target = Date.parse(date + 'T' + time + ':00' + offset);
      if (isNaN(target)) return;
      var endAttr = el.getAttribute('data-end') || '';
      var end = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/.test(endAttr) ? Date.parse(endAttr + ':00' + offset) : NaN;
      el.style.fontVariantNumeric = 'tabular-nums';
      var tick = function () {
        var now = Date.now();
        var diff = target - now;
        if (diff <= 0) {
          var left = end - now;
          if (isNaN(end)) {
            el.textContent = el.getAttribute('data-live-label') || 'Live now';
          } else if (left > 0) {
            var ls = Math.floor(left / 1000);
            el.textContent = (el.getAttribute('data-live-label') || 'Live now') + ' · ends in ' + pad(Math.floor(ls / 3600)) + 'h ' + pad(Math.floor((ls % 3600) / 60)) + 'm';
            el.hidden = false;
            return;
          } else {
            el.textContent = el.getAttribute('data-ended-label') || 'Sale ended';
          }
          el.hidden = false;
          clearInterval(el.__ftsTimer);
          return;
        }
        var s = Math.floor(diff / 1000);
        var d = Math.floor(s / 86400), h = Math.floor((s % 86400) / 3600), m = Math.floor((s % 3600) / 60), sec = s % 60;
        el.textContent = (d > 0 ? d + 'd ' : '') + pad(h) + 'h ' + pad(m) + 'm ' + pad(sec) + 's to go';
        el.hidden = false;
      };
      tick();
      el.__ftsTimer = setInterval(tick, 1000);
    });
  }

  function initIcs(scope) {
    scope.querySelectorAll('[data-fts-ics]').forEach(function (a) {
      var d = a.dataset;
      var now = new Date();
      var stamp = now.getUTCFullYear() + pad(now.getUTCMonth() + 1) + pad(now.getUTCDate()) + 'T000000Z';
      var esc = function (s) { return (s || '').replace(/\\/g, '\\\\').replace(/,/g, '\\,').replace(/;/g, '\\;').replace(/\r?\n/g, '\\n'); };
      var lines = [
        'BEGIN:VCALENDAR', 'VERSION:2.0', 'PRODID:-//Fame on Central//Teacher Sale//EN',
        'BEGIN:VEVENT', 'UID:' + (d.uid || 'teacher-sale') + '@fameoncentral.com', 'DTSTAMP:' + stamp,
        'DTSTART;TZID=' + d.tz + ':' + d.start, 'DTEND;TZID=' + d.tz + ':' + d.end,
        'SUMMARY:' + esc(d.title),
        'DESCRIPTION:' + esc(d.details),
        'LOCATION:' + esc(d.location),
        'BEGIN:VALARM', 'TRIGGER:-PT15H', 'ACTION:DISPLAY', 'DESCRIPTION:' + esc(d.title), 'END:VALARM',
        'END:VEVENT', 'END:VCALENDAR'
      ];
      a.href = 'data:text/calendar;charset=utf-8,' + encodeURIComponent(lines.join('\r\n'));
    });
  }

  function initShare(scope) {
    scope.querySelectorAll('[data-fts-share]').forEach(function (a) {
      if (a.dataset.ftsDone) return;
      a.dataset.ftsDone = '1';
      a.href += '&body=' + encodeURIComponent((a.dataset.body || '') + ' ' + location.href.split('#')[0]);
    });
  }

  function copyText(text) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text).catch(function () { return legacyCopy(text); });
    }
    return legacyCopy(text);
  }

  function legacyCopy(text) {
    return new Promise(function (resolve, reject) {
      var ta = document.createElement('textarea');
      ta.value = text;
      ta.setAttribute('readonly', '');
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      var ok = false;
      try { ok = document.execCommand('copy'); } catch (e) { ok = false; }
      document.body.removeChild(ta);
      ok ? resolve() : reject();
    });
  }

  function initCopy(scope) {
    scope.querySelectorAll('[data-fts-copy]').forEach(function (btn) {
      if (btn.dataset.ftsDone) return;
      btn.dataset.ftsDone = '1';
      var box = btn.closest('[data-fts-code]');
      var label = btn.querySelector('[data-fts-copy-label]') || btn;
      var status = box && box.querySelector('[data-fts-copy-status]');
      var original = label.textContent;
      btn.addEventListener('click', function () {
        var code = btn.getAttribute('data-fts-copy');
        copyText(code).then(function () {
          label.textContent = 'Copied!';
          if (box) box.classList.add('is-copied');
          if (status) status.textContent = 'Code ' + code + ' copied to clipboard';
        }, function () {
          // Copy blocked: select the code so the customer can copy it manually
          var value = box && box.querySelector('.fts-code__value');
          if (value && window.getSelection) {
            var range = document.createRange();
            range.selectNodeContents(value);
            var sel = window.getSelection();
            sel.removeAllRanges();
            sel.addRange(range);
          }
          label.textContent = 'Code selected';
        }).then(function () {
          clearTimeout(btn.__ftsReset);
          btn.__ftsReset = setTimeout(function () {
            label.textContent = original;
            if (box) box.classList.remove('is-copied');
            if (status) status.textContent = '';
          }, 2000);
        });
      });
    });
  }

  function initSmoothScroll() {
    if (window.__ftsScroll) return;
    window.__ftsScroll = true;
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('.fts a[href^="#"]');
      if (!a) return;
      var id = a.getAttribute('href').slice(1);
      var t = id && document.getElementById(id);
      if (!t) return;
      e.preventDefault();
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      t.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      history.replaceState(null, '', '#' + id);
    });
  }

  function initSticky() {
    var bar = document.querySelector('[data-fts-sticky]');
    var heroCta = document.querySelector('[data-fts-hero-cta]');
    if (!bar || !heroCta || !('IntersectionObserver' in window)) return;
    var target = document.getElementById(bar.getAttribute('data-target') || 'fts-signup');
    var pastHero = false, reached = false;
    var update = function () { bar.classList.toggle('is-visible', pastHero && !reached); };
    new IntersectionObserver(function (e) {
      pastHero = !e[0].isIntersecting && e[0].boundingClientRect.top < 0; update();
    }).observe(heroCta);
    if (target) {
      new IntersectionObserver(function (e) {
        reached = e[0].isIntersecting || e[0].boundingClientRect.top < 0; update();
      }).observe(target);
    }
  }

  function init(scope) {
    scope = scope || document;
    initCountdown(scope);
    initIcs(scope);
    initShare(scope);
    initCopy(scope);
  }

  function boot() { init(document); initSmoothScroll(); initSticky(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();

  document.addEventListener('shopify:section:load', function (e) { init(e.target); initSticky(); });
})();
